<template>
  <el-table-column :label="label" :prop="prop" class-name="billing-ym" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '請求年月'
    },
    prop: {
      type: String,
      default: 'billing_ym'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.billing-ym {
      width: 9.5em;
    }
  }
}
</style>
